import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storageSession from "redux-persist/lib/storage/session";
import persistReducer from "redux-persist/lib/persistReducer";
import authReducer from "../Redux/authSlice";
import subscriptionReducer from "../Redux/subscriptionSlice";
import orgReducer from "../Redux/orgDetailsSlice";
import dashboardSlice from "../Redux/dashboardSlice";
import errorReducer from "../Redux/errorSlice";
import loaderReducer from "../Redux/loaderSlice";
import fhsDrilldownReducer from "../Redux/fhsDrilldownRedux";
import navigationHistoryReducer from "../Redux/navigationHistorySlice";
import selectedFilterSlice from "../Redux/selectedFilterSlice";
import financialHealthScoreAnalysisSlice from "../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import healthAnalysisSlice from "../rtk-query/features/healthAnalysis/healthAnalysisSlice";
import newClusterSlice from "../Redux/newClusterSlice";
import maintenanceSlice from "../Redux/maintenanceSlice";
import campaignHistorySlice from "../Redux/campaignHistorySlice";
import privilegesSlice from "../Redux/privilegesSlice";
import { opportunitiesAnalysisSlice } from "../rtk-query/features/dashboard/opportunities/opportunitiesAnalysisSlice";
import { ghostConsumerAnalysisSlice } from "../rtk-query/features/dashboard/ghostConsumer/ghostConsumerAnalysisSlice";
import { secondaryConsumerAnalysisSlice } from "../rtk-query/features/dashboard/secondaryConsumer/secondaryConsumerAnalysisSlice";
import { topCompetitorsAnalysisSlice } from "../rtk-query/features/dashboard/topCompetitors/topCompetitorsAnalysisSlice";
import { fileAnalyticsAnalysisSlice } from "../rtk-query/features/dashboard/fileAnalytics/fileAnalyticsAnalysisSlice";
import { missedRevenueAnalysisSlice } from "../rtk-query/features/dashboard/missedRevenue/missedRevenueAnalysisSlice";
import { topMerchantsAnalysisSlice } from "../rtk-query/features/dashboard/topMerchants/topMerchantsAnalysisSlice";
import { consumerDemographicsAnalysisSlice } from "../rtk-query/features/dashboard/consumerDemographics/consumerDemographicsAnalysisSlice";
import { topPersonaAnalysisSlice } from "../rtk-query/features/dashboard/topPersona/topPersonaAnalysisSlice";
import { rtkQueryErrorLogger } from "../rtk-query/features/rtkQueryErrorLogger";
import { registrationSlice } from "../rtk-query/features/auth/register/registrationSlice";
import chatbotSlice from "../rtk-query/features/chatbot/chatbotSlice";
import { chatbotSidebarToolsSlice } from "../rtk-query/features/chatbot/chatbotSidebarToolsSlice";

import { emailTemplatesSlice } from "../rtk-query/features/campaign/email-campaign/emailTemplatesSlice";
import { emailCampaignsSlice } from "../rtk-query/features/campaign/email-campaign/emailCampaignsSlice";
import { paymentHistorySlice } from "../rtk-query/features/paymentHistory/paymentHistorySlice";
import { consumerListSlice } from "../rtk-query/features/campaign/email-campaign/consumerListSlice";
import { consumerListDetailsSlice } from "../rtk-query/features/campaign/email-campaign/consumerListDetailsSlice";
import { signUpSlice } from "../rtk-query/features/auth/register/signUpSlice";
import { faqSlice } from "../rtk-query/features/faq/faqSlice";
import { stripeSlice } from "../rtk-query/features/stripe/stripeSlice";
import { userManagementSlice } from "../rtk-query/features/usermanagement/userManagementSlice";
import { infiniteBankPerformanceMetricsSlice } from "../rtk-query/features/infiniteBankPerformanceMetricsSlice/infiniteBankPerformanceMetricsSlice";
import { insightsAndRecommendationSlice } from "../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";
import { contactUsSlice } from "../Redux/contactUsSlice";
import { newInitialFilterDataSlice } from "../Redux/newInitialFilterDataSlice";
import paginationSlice from "../Redux/paginationSlice";
import { notificationRTK } from "../rtk-query/features/usernotification/notificationRTK";
import notificationSlice from "../rtk-query/features/usernotification/notificationSlice";
import cohortSlice from "../rtk-query/features/cohort/cohortSlice";
import ewiSlice from "../rtk-query/features/downloadFHSReport/downloadFHSReportSlice";
import lockedCampaignSlice from "../rtk-query/features/lockedCampaignSlice";
import { downloadFHSReportRTK } from "../rtk-query/features/downloadFHSReport/downloadFHSReportRTK";
import { autoPilotLookupsSlice } from "../rtk-query/features/campaign/email-campaign/autoPilotLookupsSlice";
import { bankingServicesAnalysisSlice } from "../rtk-query/features/dashboard/BankingServices/bankingServicesAnalysisSlice";
import { trendRTK } from "../rtk-query/features/dashboard/trends/trendRTK";
import { cohortRTK } from "../rtk-query/features/cohort/cohortRTK";
// import { analyticsMiddleware } from "../analytics/middleware/analyticsMiddleware";

const rootPersistConfig = {
  key: "root",
  storage: storageSession,
  blacklist: ["authReducer"],
};

const rootReducer = combineReducers({
  authReducer: authReducer,
  orgReducer: orgReducer,
  dashboardReducer: dashboardSlice,
  errorReducer: errorReducer,
  subscriptionReducer: subscriptionReducer,
  loaderReducer: loaderReducer,
  stripeReducer: stripeSlice.reducer,
  infiniteBankPerformanceMetricsReducer:
    infiniteBankPerformanceMetricsSlice.reducer,
  signUpReducer: signUpSlice.reducer,
  faqReducer: faqSlice.reducer,
  navigationHistoryReducer: navigationHistoryReducer,
  selectedFilterSlice: selectedFilterSlice,
  fhsDrilldownReducer: fhsDrilldownReducer,
  chatbotReducer: chatbotSlice,
  financialHealthScoreAnalysisReducer: financialHealthScoreAnalysisSlice,
  healthAnalysisReducer: healthAnalysisSlice,
  notificationReducer: notificationSlice,
  lockedCampaignReducer: lockedCampaignSlice,
  newClusterReducer: newClusterSlice,
  maintenanceReducer: maintenanceSlice,
  campaignHistoryReducer: campaignHistorySlice,
  privilegesReducer: privilegesSlice,
  paginationReducer: paginationSlice,
  cohortReducer: cohortSlice,
  ewiReducer: ewiSlice,
  emailCampaigns: emailCampaignsSlice.reducer,
  paymentHistoryReducer: paymentHistorySlice.reducer,
  emailTemplates: emailTemplatesSlice.reducer,
  consumerList: consumerListSlice.reducer,
  consumerListDetails: consumerListDetailsSlice.reducer,
  chatbotSidebarToolsReducer: chatbotSidebarToolsSlice.reducer,
  userManagementReducer: userManagementSlice.reducer,
  contactUsReducer: contactUsSlice.reducer,
  [opportunitiesAnalysisSlice.reducerPath]: opportunitiesAnalysisSlice.reducer,
  [ghostConsumerAnalysisSlice.reducerPath]: ghostConsumerAnalysisSlice.reducer,
  [secondaryConsumerAnalysisSlice.reducerPath]:
    secondaryConsumerAnalysisSlice.reducer,
  [topCompetitorsAnalysisSlice.reducerPath]:
    topCompetitorsAnalysisSlice.reducer,
  [bankingServicesAnalysisSlice.reducerPath]:
    bankingServicesAnalysisSlice.reducer,
  [fileAnalyticsAnalysisSlice.reducerPath]: fileAnalyticsAnalysisSlice.reducer,
  [missedRevenueAnalysisSlice.reducerPath]: missedRevenueAnalysisSlice.reducer,
  [topMerchantsAnalysisSlice.reducerPath]: topMerchantsAnalysisSlice.reducer,
  [consumerDemographicsAnalysisSlice.reducerPath]:
    consumerDemographicsAnalysisSlice.reducer,
  [topPersonaAnalysisSlice.reducerPath]: topPersonaAnalysisSlice.reducer,
  [trendRTK.reducerPath]: trendRTK.reducer,
  [registrationSlice.reducerPath]: registrationSlice.reducer,
  [autoPilotLookupsSlice.reducerPath]: autoPilotLookupsSlice.reducer,
  [insightsAndRecommendationSlice.reducerPath]:
    insightsAndRecommendationSlice.reducer,
  [notificationRTK.reducerPath]: notificationRTK.reducer,
  [cohortRTK.reducerPath]: cohortRTK.reducer,
  [downloadFHSReportRTK.reducerPath]: downloadFHSReportRTK.reducer,
  [newInitialFilterDataSlice.reducerPath]: newInitialFilterDataSlice.reducer,
});

export const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableStateInvariant: false,
    }).concat([
      opportunitiesAnalysisSlice.middleware,
      ghostConsumerAnalysisSlice.middleware,
      secondaryConsumerAnalysisSlice.middleware,
      topCompetitorsAnalysisSlice.middleware,
      bankingServicesAnalysisSlice.middleware,
      fileAnalyticsAnalysisSlice.middleware,
      missedRevenueAnalysisSlice.middleware,
      topMerchantsAnalysisSlice.middleware,
      consumerDemographicsAnalysisSlice.middleware,
      topPersonaAnalysisSlice.middleware,
      trendRTK.middleware,
      // bondScoreTrendSlice.middleware,
      // ghostConsumersTrendSlice.middleware,
      // missingRevenueTrendSlice.middleware,
      // opportunitiesTrendSlice.middleware,
      // secondaryConsumersTrendSlice.middleware,
      registrationSlice.middleware,
      autoPilotLookupsSlice.middleware,
      insightsAndRecommendationSlice.middleware,
      notificationRTK.middleware,
      cohortRTK.middleware,
      downloadFHSReportRTK.middleware,
      newInitialFilterDataSlice.middleware,
      // analyticsMiddleware,
      rtkQueryErrorLogger,
    ]),
});
export default store;
